import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, faUsers, faHardHat, faIdCard, faClock, faBook, 
  faClipboardList, faMoneyCheckAlt, faMoneyBillWave, faHandsHelping, 
  faImage, faEye, faStar, faQrcode, faUser, faLockOpen,
  faSadCry,
  faWallet,
  faSearch, faClipboardQuestion, faClockRotateLeft
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import bluehandsimage from '../../assets/gdashboard/BlueHands.webp';

function BlueHandsHome() {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [searchQuery, setSearchQuery] = useState("");
  const [category, setCategory] = useState("Labour");
  const [city, setCity] = useState("Mumbai");

  const handleSearch = () => {
    // console.log("Search Query:", searchQuery);
    // console.log("Category:", category);
    // console.log("City:", city);
    // API Call for database fetching logic here
  };


  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-6'>JobsAfter45</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex flex-col items-center mb-8 mt-16 border-2 border-yellow-200 rounded-md p-6">
            <div className="flex flex-row justify-center md:flex-row md:space-x-4 space-y-4 md:space-y-0 w-full">
              <label>
                <FontAwesomeIcon icon={faSearch} className='text-yellow-200 text-lg ml-4'/>
              </label>
              <input
                type="text"
                placeholder="Enter search keywords eg Strategy, Mentorship etc"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
              >
                <optgroup label="Professional and Managerial Roles">
                    <option value="strategy">Strategy</option>
                    <option value="business-process-improvement">Business Process Improvement</option>
                    <option value="industry-specific-expertise">Industry-Specific Expertise</option>
                    <option value="project-manager">Project Manager</option>
                    <option value="operations-manager">Operations Manager</option>
                    <option value="c-level-positions">C-Level Positions</option>
                    <option value="vice-president">Vice President</option>
                    <option value="director-roles">Director Roles</option>
                  </optgroup>
                  <optgroup label="Education and Training">
                    <optgroup label="Teaching and Academia">
                      <option value="school-teacher">School Teacher</option>
                      <option value="college-professor">College Professor</option>
                      <option value="online-educator">Online Educator</option>
                    </optgroup>
                    <optgroup label="Corporate Training">
                      <option value="soft-skills-training">Soft Skills Training</option>
                      <option value="technical-skills-training">Technical Skills Training</option>
                      <option value="leadership-development">Leadership Development</option>
                    </optgroup>
                    <optgroup label="Mentorship and Coaching">
                      <option value="career-coaching">Career Coaching</option>
                      <option value="life-coaching">Life Coaching</option>
                      <option value="professional-mentoring">Professional Mentoring</option>
                    </optgroup>
                  </optgroup>
                  <optgroup label="Creative and Content Roles">
                    <option value="technical-writing">Technical Writing</option>
                    <option value="blogging">Blogging</option>
                    <option value="book-writing">Book Writing</option>
                    <option value="vlogging">Vlogging</option>
                    <option value="online-courses">Online Courses</option>
                    <option value="graphic-design">Graphic Design</option>
                    <option value="illustration">Illustration</option>
                  </optgroup>
                  <optgroup label="Sales and Marketing">
                    <option value="sales-consultancy">Sales Consultancy</option>
                    <option value="digital-marketing">Digital Marketing</option>
                    <option value="brand-management">Brand Management</option>
                  </optgroup>
                  <optgroup label="Entrepreneurial and Freelance Roles">
                    <option value="small-business-ownership">Small Business Ownership</option>
                    <option value="freelancing">Freelancing</option>
                    <option value="franchising">Franchising</option>
                  </optgroup>
                  <optgroup label="Customer and Client Relations">
                    <option value="customer-support">Customer Support Specialist</option>
                    <option value="client-relationship-manager">Client Relationship Manager</option>
                  </optgroup>
                  <optgroup label="Healthcare and Wellness">
                    <option value="healthcare-support">Healthcare Support Roles</option>
                    <option value="health-coaching">Health Coaching</option>
                    <option value="counseling-therapy">Counseling and Therapy</option>
                  </optgroup>
                  <optgroup label="Technology and IT">
                    <option value="it-consultant">IT Consultant</option>
                    <option value="data-analysis">Data Analysis</option>
                    <option value="technical-support">Technical Support</option>
                  </optgroup>
                  <optgroup label="Finance and Legal">
                    <option value="accounting-bookkeeping">Accounting and Bookkeeping</option>
                    <option value="financial-planning">Financial Planning</option>
                    <option value="legal-services">Legal Services</option>
                  </optgroup>
                  <optgroup label="Government and Non-Profit">
                    <option value="public-administration">Public Administration</option>
                    <option value="non-profit-management">Non-Profit Management</option>
                    <option value="policy-advisor">Policy Advisor</option>
                  </optgroup>
                  <optgroup label="Hospitality and Tourism">
                    <option value="event-planning">Event Planning</option>
                    <option value="tourism-roles">Tour Guide, Travel Consultant</option>
                    <option value="hotel-management">Hotel Management</option>
                  </optgroup>
                  <optgroup label="Agriculture and Environment">
                    <option value="farming-agribusiness">Farming and Agribusiness</option>
                    <option value="environmental-consultancy">Environmental Consultancy</option>
                  </optgroup>
                  <optgroup label="Skilled Trades and Crafts">
                    <option value="handyman-services">Handyman Services</option>
                    <option value="artisan-work">Artisan Work</option>
                  </optgroup>
                  <optgroup label="Other Flexible Roles">
                    <option value="remote-work">Remote Work Opportunities</option>
                    <option value="part-time-jobs">Part-Time Jobs</option>
                    <option value="gig-economy-roles">Gig Economy Roles</option>
                  </optgroup>

              </select>
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="Any Location">Any Location</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Ahmedabad">Ahmedabad</option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Chennai">Chennai</option>
                <option value="Pune">Pune</option>
              </select>
            </div>
            <div className='mt-4'>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Search
              </button>
              <button
                onClick={handleSearch}
                className="ml-4 bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Instant
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/fortyfivejobs-iamavailable" icon={faHandsHelping} text="I am Available" />
            <CardLink to="/myprofile-fortyfiveprofile" icon={faUser} text="My 45+ Profile" />
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious/fortyfive" icon={faIdCard} text="My Secure Digital Card" />
            <CardLink to={`/pub/fortyfive/${userCode}`} icon={faLockOpen} text="My Public Digital Card" />

            <CardLink to="/chronocheck-home" icon={faClock} text="My Attendance" />
            <CardNoLink to="" icon={faBook} text="My Work Diary" />
            <CardNoLink to="" icon={faUser} text="Write My Bio-Data" />
            <CardNoLink to="" icon={faMoneyBillWave} text="Payments" />
            {/* <CardLink to="/contact-genious-change-profile-image" icon={faImage} text="Profile Image" /> */}
            <CardNoLink to="" icon={faClipboardQuestion} text="My Shortlisted Jobs" />
            <CardNoLink to="" icon={faClockRotateLeft} text="Jobs I Applied" />
            <CardNoLink to="" icon={faQrcode} text="My Job Search Log" />
            <CardNoLink to="" icon={faEye} text="Who Searched Me" />
            <CardNoLink to="" icon={faWallet} text="Price List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default BlueHandsHome;


